import React, { Component } from "react";

import ApplicatedQuestionItemVisualization from "./ApplicatedQuestionItemVisualization/ApplicatedQuestionItemVisualization";

import "./styles.css";

class ApplicatedQuestionItemsMenuVisualization extends Component {
  render() {
    return (
      <ul className="applicated-question-item-list">
        {this.props.items.map(item => (
          <li key={item.id}>
            <ApplicatedQuestionItemVisualization
              finished={this.props.finished}
              questionId={this.props.questionId}
              questionType={this.props.questionType}
              itemData={item}
              userAnswer={this.props.userAnswer.find(
                answer => answer.id === item.id
              )}
              answerChanger={this.props.answerChanger}
              showCorrectAnswer={this.props.showCorrectAnswer}
              allowAnswerEdit={this.props.allowAnswerEdit}
            />
          </li>
        ))}
      </ul>
    );
  }
}

export default ApplicatedQuestionItemsMenuVisualization;
